import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@targetStylePath'
import App from './App.jsx'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from '@/queries/client'
import './i18n'
import { useOrgInfoStore } from '@store/common/useOrgInfoStore.js'
import { USE_TYPE } from '@constants/appTarget.js'
import { POPUP_SEGMENT } from '@constants/hanaPopupPaths.js'
import { canUseNativeSchema } from '@utils/hanaSchema.js'
import { restorePreviewFrames } from '@utils/hanaPreviewFrame.js'

if (__APP_TARGET__ === 'hana') {
  useOrgInfoStore.getState().setUseType(USE_TYPE.hana)

  if (window.location.pathname.startsWith(`/${POPUP_SEGMENT}/`)) {
    document.documentElement.classList.add('hana-transparent-page')
  }

  if (!canUseNativeSchema()) restorePreviewFrames()
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>
)
